import React from 'react'

import Reflux from 'reflux-react-16'
import _ from 'lodash'

import Countries from '../../../utils/Countries.js'

import trackTraceEmailTemplate from '../../../../server/functions/mail/templates/trackTraceEmailTemplate.js'
import cancelEmailTemplate from '../../../../server/functions/mail/templates/cancelEmailTemplate.js'

import {
    Colors,
    H3,
    Tab,
    Tabs,
    Row,
    Card,
    ListItem,
    Panel,
    Button,
    Popup,
    S2
} from '@components/UI/index.js'
import EmailPreview from '@components/settings/EmailPreview.js'
import {
    Editor,
    FormStack,
    Input,
    Toggle,
    Select
} from '@components/UI/forms/index.js'
import retourConfirmationTemplate from '../../../../server/functions/mail/templates/retourConfirmationTemplate.js'
import Languages from '@utils/Languages.js'
import naturalSortBy from 'src/utils/naturalSortBy.js'
import t from 'src/helpers/Languages.js'

const emailComments = {
    confirmedEmails: 'parcelMailCommentConfirmed',
    shippedEmails: 'parcelMailCommentShipped',
    deliveredEmails: 'parcelMailCommentDelivered',
    cancelEmails: 'parcelMailCommentCancelled',
    retourConfirmationEmails: 'parcelMailCommentRetour'
}

// The Track & Trace mail of each tab, the trigger that sends it
const trackTraceTriggers = {
    confirmedEmails: 'confirmed',
    shippedEmails: 'shipped',
    deliveredEmails: 'delivered'
}

class CommunicationSettings extends Reflux.Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedEmails: 'confirmedEmails',
            selectedEmailIndex: 0
        }
    }

    componentDidMount() {
        if (this.props?.location?.state?.selectedEmails) {
            this.setState({selectedEmails: this.props.location.state.selectedEmails})
        }
    }

    onChangeValue(path, event) {
        const user = {...this.props.user}

        _.set(user.settings, path, event.target.values ?? event.target.value)

        this.props.onChange(user)
    }

    onChangeChecked(path, event) {
        const user = {...this.props.user}

        _.set(user.settings, path, !!event.target.checked)

        this.props.onChange(user)
    }

    onChangeFileUpload(path, fileName, value) {
        const user = {...this.props.user}

        _.set(user.settings, path, value)

        this.props.onChange(user, path)
    }

    render() {
        const {reseller, user} = this.props
        const {selectedEmails, selectedEmailIndex} = this.state

        const returnsEnabled = _.some(_.keys(reseller.settings.parcels.products?.Retour), (carrier) => {
            return reseller.settings.parcels.products.Retour[carrier]
        })

        const emails = user.settings.parcels.emailNotifications[selectedEmails] || []
        const email = emails[selectedEmailIndex] || emails[0]

        return (
            <Row style={{gap: 24}}>
                <Card shadow style={{width: 800, padding: 24}}>
                    <H3 style={{marginBottom: 36}}>{t('parcelMailTitle')}</H3>

                    <Tabs
                        style={{marginBottom: 30}}
                        value={selectedEmails}
                        onChange={(event) => this.setState({selectedEmails: event.target.value, selectedEmailIndex: 0})}
                    >
                        <Tab value='confirmedEmails'>{t('parcelMailTabConfirmed')}</Tab>
                        <Tab value='shippedEmails'>{t('parcelMailTabShipped')}</Tab>
                        <Tab value='deliveredEmails'>{t('delivered')}</Tab>
                        <Tab value='cancelEmails'>{t('parcelMailTabCancelled')}</Tab>
                        {returnsEnabled && <Tab value='retourConfirmationEmails'>{t('parcelMailTabRetour')}</Tab>}
                    </Tabs>

                    <div style={{display: 'flex'}}>
                        <div style={{width: 200, height: '100%'}}>
                            <Panel style={{marginBottom: 24, maxHeight: 300, overflowY: 'auto'}}>
                                {emails.map((email, index) => (
                                    <ListItem
                                        key={`${selectedEmails}_${index}`}
                                        active={selectedEmailIndex === index}
                                        onClick={() => this.setState({selectedEmailIndex: index})}
                                        iconButtons={!email.default && [{
                                            icon: 'mdi mdi-delete',
                                            onClick: async () => {
                                                if (!await this.popup.open(Languages.deleteCountry['NL'], Languages.deleteCountryText['NL'])) return

                                                user.settings.parcels.emailNotifications[selectedEmails].splice(index, 1)

                                                this.setState({selectedEmailIndex: 0})

                                                this.props.onChange(user, `parcels.emailNotifications.${selectedEmails}`)

                                                this.popup.close()
                                            }

                                        }]}
                                    >
                                        <div>
                                            <span>{email.default ? Languages.otherCountries['NL'] : Countries.find((country) => country.code2 === email.country)?.name}</span>
                                            <S2>{email.enabled ? Languages.enabled['NL'] : Languages.disabled['NL']}</S2>
                                        </div>
                                    </ListItem>
                                ))}
                            </Panel>

                            <Button
                                label={Languages.addCountry['NL']}
                                icon='mdi mdi-plus'
                                variant='outline'
                                onClick={async () => {
                                    // Filter countries that are not already used
                                    const countryOptions = _.filter(Countries, (country) => {
                                        return !_.some(Object.values(user.settings.parcels.emailNotifications[selectedEmails]), (email) => {
                                            return email.country === country.code2
                                        })
                                    }).map((country) => {
                                        return {value: country.code2, title: country.name}
                                    })

                                    this.popup.setInput({
                                        type: 'select',
                                        label: Languages.country['NL'],
                                        options: countryOptions,
                                        value: countryOptions[0]?.value
                                    })

                                    const country = await this.popup.open(Languages.addCountry['NL'])
                                    if (country === undefined) return
                                    this.popup.close()

                                    const otherCountries = user.settings.parcels.emailNotifications[selectedEmails].pop()

                                    user.settings.parcels.emailNotifications[selectedEmails].push({
                                        enabled: true,
                                        language: Languages.country[country] ? country : 'EN',
                                        country: country,
                                        default: false,
                                        senderName: '',
                                        replyTo: '',
                                        subject: '',
                                        body: ''
                                    })

                                    user.settings.parcels.emailNotifications[selectedEmails] = naturalSortBy(user.settings.parcels.emailNotifications[selectedEmails], (email) => Countries.find((c) => c.code2 === email.country)?.name)

                                    user.settings.parcels.emailNotifications[selectedEmails] = [...user.settings.parcels.emailNotifications[selectedEmails], otherCountries]

                                    this.props.onChange(user, `parcels.emailNotifications.${selectedEmails}`)
                                }}
                            />

                        </div>

                        {email &&
                            <FormStack style={{flex: 1, marginLeft: 30, height: '100%'}}>
                                <Toggle
                                    label={Languages.enabled['NL']}
                                    checked={email.enabled}
                                    onChange={(event) => this.onChangeChecked(`parcels.emailNotifications.${selectedEmails}.${selectedEmailIndex}.enabled`, event)}
                                />

                                <Select
                                    label={Languages.language['NL']}
                                    value={email.language}
                                    options={[
                                        {value: 'NL', title: 'Nederlands'},
                                        {value: 'EN', title: 'Engels'},
                                        {value: 'FR', title: 'Frans'},
                                        {value: 'DE', title: 'Duits'},
                                        {value: 'ES', title: 'Spaans'},
                                        {value: 'IT', title: 'Italiaans'}
                                    ]}
                                    onChange={(event) => {
                                        user.settings.parcels.emailNotifications[selectedEmails][selectedEmailIndex].language = event.target.value
                                        this.props.onChange(user, `parcels.emailNotifications.${selectedEmails}.${selectedEmailIndex}.language`)
                                    }}
                                />

                                <Input
                                    label={t('mailSenderName')}
                                    placeholder={user.name}
                                    value={email.senderName}
                                    onChange={(event) => this.onChangeValue(`parcels.emailNotifications.${selectedEmails}.${selectedEmailIndex}.senderName`, event)}
                                />

                                <Input
                                    label={t('mailSenderEmail')}
                                    placeholder={(user.settings.useOwnSMTP && user.settings.smtpUser) || user.email || user.loginEmail}
                                    value={email.replyTo}
                                    onChange={(event) => this.onChangeValue(`parcels.emailNotifications.${selectedEmails}.${selectedEmailIndex}.replyTo`, event)}
                                />

                                <Editor
                                    label={t('mailSubject')}
                                    as='input'
                                    tags={['bedrijfsnaam', 'naam', 'referentie', 'vervoerder', 'trackTraceCode']}
                                    value={email.subject}
                                    onChange={(event) => this.onChangeValue(`parcels.emailNotifications.${selectedEmails}.${selectedEmailIndex}.subject`, event)}
                                />

                                <Editor
                                    label={t('message')}
                                    tags={['bedrijfsnaam', 'naam', 'referentie', 'vervoerder', 'trackTraceCode', 'trackTraceLink', user.settings.parcels.returnPortalActive && 'retourlink']}
                                    value={email.body}
                                    onChange={(event) => this.onChangeValue(`parcels.emailNotifications.${selectedEmails}.${selectedEmailIndex}.body`, event)}
                                    comment={t(emailComments[selectedEmails])}
                                />
                            </FormStack>
                        }
                    </div>
                </Card>

                {email && trackTraceTriggers[selectedEmails] &&
                    <div style={{width: 650}}>
                        <EmailPreview
                            type='trackTrace'
                            action={trackTraceTriggers[selectedEmails]}
                            language={email.language}
                            html={trackTraceEmailTemplate({
                                logo: user.settings.logo || '/images/logoPlaceholder.png',
                                message: email.body?.replace(/\n/g, '<br/>') || '',
                                color: user.settings.color || Colors.brandColor,
                                parcel: {
                                    senderAddress: {
                                        name: user.name
                                    },
                                    trackTrace: 'VEL73BF282DF2',
                                    reference: '831012'
                                },
                                addressHeader: Languages.deliveryAddress[email.language],
                                senderHeader: Languages.sender[email.language],
                                referenceHeader: Languages.reference[email.language],
                                buttonText: Languages.followShipment[email.language],
                                address: {
                                    name: 'John Doe',
                                    attention: '',
                                    street: 'Straatnaam',
                                    nr: '123',
                                    addition: '',
                                    street2: '',
                                    postalCode: '1234 AB',
                                    city: 'Plaats',
                                    country: 'NL'
                                }
                            }, window.location.origin)}
                        />
                    </div>
                }

                {email && selectedEmails === 'cancelEmails' &&
                    <div style={{width: 650}}>
                        <EmailPreview
                            type='cancelEmail'
                            html={cancelEmailTemplate({
                                logo: user.settings.logo || '/images/logoPlaceholder.png',
                                color: user.settings.color || Colors.brandColor,
                                message: email.body?.replace(/\n/g, '<br/>') || '',
                                addressHeader: Languages.deliveryAddress[email.language],
                                senderHeader: Languages.sender[email.language],
                                referenceHeader: Languages.reference[email.language],
                                parcel: {
                                    senderAddress: {
                                        name: user.name
                                    },
                                    address: {
                                        name: 'John Doe',
                                        attention: '',
                                        street: 'Straatnaam',
                                        nr: '123',
                                        addition: '',
                                        street2: '',
                                        postalCode: '1234 AB',
                                        city: 'Plaats',
                                        country: 'NL'
                                    },
                                    trackTrace: 'VEL73BF282DF2',
                                    reference: '831012'
                                }

                            }, window.location.origin)}
                        />
                    </div>
                }

                {email && selectedEmails === 'retourConfirmationEmails' &&
                    <div style={{width: 650}}>
                        <EmailPreview
                            type='retourConfirmation'
                            html={retourConfirmationTemplate({
                                logo: user.settings.logo || '/images/logoPlaceholder.png',
                                color: user.settings.color || Colors.brandColor,
                                message: email.body?.replace(/\n/g, '<br/>') || '',
                                addressHeader: Languages.returnAddress[email.language],
                                referenceHeader: Languages.reference[email.language],
                                buttonText: Languages.followShipment[email.language],
                                parcel: {
                                    senderAddress: user.settings.parcels.customReturnAddress ?
                                        user.settings.parcels.returnAddress :
                                        user.address,
                                    trackTrace: 'VEL73BF282DF2',
                                    reference: '831012'
                                }
                            }, window.location.origin)}
                        />
                    </div>
                }

                <Popup ref={(popup) => this.popup = popup} />

            </Row>
        )
    }
}

export default CommunicationSettings
